import { getProjects, getTutorials } from '../helpers/utils'

const initialState = {
  projects: getProjects(),
  tutorials: getTutorials()
}

function ProjectsReducer(state=initialState, action){
  switch(action.type){
    default:
      return state
  }
}

export default ProjectsReducer


// WEBPACK FOOTER //
// ./app/reducers/ProjectsReducer.js